import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/home';
import Import from './components/import'; 
import Export from './components/export';
import Header from './components/header';
import Importresult from './components/importresult';
import CbeToIdpms from './components/CbeToIdpms';
import CsbToEdpms from './components/CsbToEdpms';
import ExportResult from './components/ExportResult';
import IdpmsResult from './components/idpmsResult';
import EdpmsResult from './components/edpmsResult';
import ImportDetails from './components/importDetails';
import CsbDetails from './components/csbDetails';
import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
  return (
        <Routes>
          <Route path="/" element={<Header />} />
          <Route path='/home' element={<Header />}/>
          <Route path="/import" element={<Import />} />
          <Route path='/export' element={<Export />} />
          <Route path='/cbetoidpms' element={<CbeToIdpms />} />
          <Route path='/csbtoedpms' element={<CsbToEdpms />} />
          <Route path='/importresult' element={<Importresult />} />
          <Route path='/ExportResult' element={<ExportResult />}/>
          <Route path='/idpmsResult' element={<IdpmsResult />}/>
          <Route path='/edpmsResult' element={<EdpmsResult />}/>
          <Route path='/cbeDetails' element={<ImportDetails />} />
          <Route path='/csbDetails' element={<CsbDetails />} />
        </Routes>
  );
}

export default App;
